import Http from '../http'

export const login = (data) => Http.post('/login', data)
export const forgot = (data) => Http.post('/forgot', data)
export const reset = (data) => Http.post('/reset', data)
